import Vue from 'vue'
import Router from 'vue-router'
/* 404 */
import error from '@/components/notFound'

Vue.use(Router)

const $router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: resolve => require(['@/components/home/home'], resolve),
      meta: { keepAlive: true }
    }, {
      path: '/homeSearch',
      name: 'homeSearch',
      component: resolve => require(['@/components/home/homeSearch'], resolve),
      meta: { keepAlive: false }
    }, {
      path: '/baikeCommon',
      name: 'baikeCommon',
      component: resolve => require(['@/components/baike/baikeCommon'], resolve),
      redirect: 'baike',
      meta: { keepAlive: true },
      children: [
        {
          path: '/baike',
          name: 'baike',
          component: resolve => require(['@/components/baike/baike'], resolve),
          meta: { keepAlive: false }
        }, {
          path: '/baikeSearch',
          name: 'searchResult',
          component: resolve => require(['@/components/baike/baikeSearchResult'], resolve),
          meta: { keepAlive: false }
        }, {
          path: '/baikeItem/:id',
          name: 'baikeItem',
          component: resolve => require(['@/components/baike/baikeItem'], resolve),
          meta: { keepAlive: false }
        }, {
          path: '/baikeNoResult',
          name: 'baikeNoResult',
          component: resolve => require(['@/components/baike/baikeNoResult'], resolve),
          meta: { keepAlive: false }
        }, {
          path: '/category',
          name: 'category',
          component: resolve => require(['@/components/baike/categoryList'], resolve),
          meta: { keepAlive: false }
        }, {
          path: '/baikeItemPre/:id',
          name: 'baikeItemPre',
          component: resolve => require(['@/components/baike/baikeItem'], resolve),
          meta: { keepAlive: false }
        }
      ]
    }, {
      path: '/newsCommon',
      name: 'news',
      component: resolve => require(['@/components/news/news'], resolve),
      redirect: '/news',
      meta: { keepAlive: true },
      children: [
        {
          path: '/news',
          name: 'newsList',
          component: resolve => require(['@/components/news/newsList'], resolve),
          meta: { keepAlive: false }
        }, 
        {
          path: '/news/:id',
          name: 'newsDetail',
          component: resolve => require(['@/components/news/newsDetail'], resolve),
          meta: { keepAlive: false }
        }, 
        {
          path: '/newspre/:id',
          name: 'newsDetailPre',
          component: resolve => require(['@/components/news/newsDetail'], resolve),
          meta: { keepAlive: false }
        }
      ]
    }, {
      path: '/achievementsCommon',
      name: 'achievements',
      component: resolve => require(['@/components/achievements/achievements'], resolve),
      redirect: '/achievements',
      meta: { keepAlive: true },
      children: [
        {
          path: '/achievements',
          name: 'list',
          component: resolve => require(['@/components/achievements/list'], resolve),
          meta: { keepAlive: false }
        }, 
        {
          path: '/achievements/:id',
          name: 'detail',
          component: resolve => require(['@/components/achievements/detail'], resolve),
          meta: { keepAlive: false }
        }
      ]
    }, {
      path: '/voice',
      name: 'voice',
      component: resolve => require(['@/components/voice/voice'], resolve),
      redirect: '/video',
      meta: { keepAlive: true },
      children: [
        {
          path: '/video',
          name: 'videoList',
          component: resolve => require(['@/components/voice/videoList'], resolve),
          meta: { keepAlive: false }
        }, {
          path: '/music',
          name: 'musicList',
          component: resolve => require(['@/components/voice/musicList'], resolve),
          meta: { keepAlive: false }
        }, {
          path: '/imgList',
          name: 'imgList',
          component: resolve => require(['@/components/voice/imgList'], resolve),
          meta: { keepAlive: false }
        }
      ]
    }, {
      path: '/resources/:id',
      name: 'resources',
      component: resolve => require(['@/components/voice/resources'], resolve),
      meta: { keepAlive: false }
    }, {
      path: '/expertCommon',
      name: 'expertCommon',
      component: resolve => require(['@/components/expert/expertCommon'], resolve),
      redirect: '/expert',
      meta: { keepAlive: false },
      children: [
        {
          path: '/expert',
          name: 'expert',
          component: resolve => require(['@/components/expert/expertList'], resolve),
          meta: { keepAlive: false }
        }, {
          path: '/expert/:id',
          name: 'expertDetail',
          component: resolve => require(['@/components/expert/expertDetail'], resolve),
          meta: { keepAlive: false }
        }
      ]
    }, 
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: resolve => require(['@/components/user/login'], resolve),
    //   meta: { keepAlive: false }
    // },
    // {
    //   path: '/register',
    //   name: 'register',
    //   component: resolve => require(['@/components/user/register'], resolve),
    //   meta: { keepAlive: false }
    // }, 
    {
      path: '/us',
      name: 'us',
      component: resolve => require(['@/components/us'], resolve),
      meta: { keepAlive: false }
    }, {
      path: '/user',
      name: 'user',
      component: resolve => require(['@/components/user/user'], resolve),
      redirect: '/user/member',
      meta: { keepAlive: false },
      children: [
        // {
        //   path: '/user/info',
        //   name: 'userInfo',
        //   component: resolve => require(['@/components/user/info'], resolve),
        //   meta: { 
        //     requireAuth: true,  // 表示进入这个路由是需要登录的
        //     keepAlive: false 
        //   }
        // }, 
        {
          path: '/user/member',
          name: 'userMember',
          component: resolve => require(['@/components/user/member'], resolve),
          meta: { 
            requireAuth: true,  // 表示进入这个路由是需要登录的
            keepAlive: false 
          }
        }
      ]
    },
    /**
    {
      path: '/findPassword',
      name: 'findPassword',
      component: resolve => require(['@/components/user/findPassword'], resolve),
      meta: { keepAlive: false }
    }, {
      path: '/binding',
      name: 'binding',
      component: resolve => require(['@/components/user/binding'], resolve),
      meta: { keepAlive: false }
    }, {
      path: '/bindOldAccount',
      name: 'bindOldAccount',
      component: resolve => require(['@/components/user/bindOldAccount'], resolve),
      meta: { keepAlive: false }
    },{
      path: '/user/phone',
      name: 'phone',
      component: resolve => require(['@/components/user/phone'], resolve),
      meta: { 
        requireAuth: true,  // 表示进入这个路由是需要登录的
        keepAlive: false 
      }
    }, {
      path: '/registerProtocol',
      name: 'registerProtocol',
      component: resolve => require(['@/components/user/registerProtocol'], resolve),
      meta: { keepAlive: false }
    }
    */
    {
      path: '*',
      name: 'error',
      component: error,
      meta: { keepAlive: false }
    }
  ]
})

export default $router;


// WEBPACK FOOTER //
// ./src/router/index.js